import React from 'react';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {ToggleIconProps} from './Accordion';

export const DefaultToggleIcon: React.FC<ToggleIconProps> = ({isOpen}) => {
  return (
    <Icon
      data-testid="accordionToggleIcon"
      size="XXS"
      asset={isOpen ? GenericIconName.ArrowUp : GenericIconName.ArrowDown}
    />
  );
};
